const legacy = require('./legacy_translation')
console.log('lgacy', legacy.fr)
const fr = {
  filters: 'Filtres',
  wanted_publication_date: "Date de publication souhaitée",
  suggest_idea: "Proposer une idée",
  category: "Catégorie",
  title: "Titre",
  description: "Description",
  optional: "optionnel",
  add_attachment: "Ajouter une pièce jointe",
  linked_calendar: "Calendrier connecté",
  box_account_name: "Nom de la boîte à idées",
  in_the_category: "Dans la catégorie",
  wanted_publication: "Publication souhaitée",
  scheduled_publication: "Publication planifiée",
  comments: "Commentaires",
  write_comment: "Écrire commentaire",
  click_to_add_publication_date: "Choisir une date",
  save: "Sauvegarder",
  submitted: "Soumise",
  scheduled: "Planifiée",
  published: "Publiée",
  denied: "Refusée",
  confirmed: "Validée",
  status_submitted: "Soumise(s)",
  status_scheduled: "Planifiée(s)",
  status_published: "Publiée(s)",
  status_confirmed: "Validée(s)",
  status_denied: "Refusée(s)",
  search: "Rechercher",
  publication_date: "Date de publication",
  box_accounts: "Boîtes à idées",
  employee: "Employé",
  date_created: "Date de création",
  order: "Tri",
  required_field: "Champs obligatoire",
  idea_box: "Boîte à idées",
  change_box: "Changer de boîte",
  deny_text: `Êtes vous sur de vouloir refuser cette idée ?
(Sélectionnez le filtre « refusée » pour la retrouver par la suite.)`,
  propose_idea: "Proposer une idée",
  archived: "Archivé",
  show_archived: "Montrer les colonnes archivées",
  hide_archived: "Cacher les colonnes archivées",
  delete_box_account: "Supprimer la boîte",
}
const en = {
  filters: 'Filters',
  wanted_publication_date: "Suggested publication date",
  suggest_idea: "Suggest an idea",
  category: "Category",
  title: "Title",
  description: "Description",
  optional: "optional",
  add_attachment: "Add attachment",
  linked_calendar: "Linked calendar",
  box_account_name: "Nom de la boîte à idées",
  in_the_category: "In the category",
  wanted_publication: "Suggested publication",
  scheduled_publication: "Scheduled publication",
  comments: "Comments",
  write_comment: "Write comment",
  click_to_add_publication_date: "Choose a date",
  save: "Save",
  submitted: "Submitted",
  scheduled: "Scheduled",
  published: "Published",
  denied: "Denied",
  confirmed: "Confirmed",
  search: "Search",
  publication_date: "Publication date",
  box_accounts: "Idea boxes",
  employee: "Employee",
  date_created: "Created date",
  order: "Order",
  required_field: "Required field",
  idea_box: "Idea box",
  change_box: "Switch box",
  deny_text: `Are you sure you want to deny this idea ?
(Choose the filter "denied" to find it again.)`,
  propose_idea: "Submit new idea",
  archived: "Archived",
  show_archived: "Show archived",
  hide_archived: "Hide archived",
  delete_box_account: "Delete box account",
}
const translation = {
  fr: Object.assign(legacy.fr, fr),
  en: Object.assign(legacy.en, en)
}
export default {
  computed: {
    t() {
      try {
        return translation[this.$root.lang] || translation.fr
      } catch (e) { return {} }
    },
  },
}
